import { render, staticRenderFns } from "./AccountLink.vue?vue&type=template&id=61ff65c5&lang=pug"
import script from "./AccountLink.vue?vue&type=script&lang=js"
export * from "./AccountLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports